import { render } from "./whatsApp_icon.vue?vue&type=template&id=5d12bb66"
import script from "./whatsApp_icon.vue?vue&type=script&lang=js"
export * from "./whatsApp_icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__